import { useQuery } from '@tanstack/react-query';
import {
  DashboardAPI,
  DashboardFilterOptions,
  FindProjectsOptions,
} from '../api';

export const useDashboardProjects = (options?: FindProjectsOptions) => {
  return useQuery({
    queryKey: ['dashboard', 'projects', options],
    queryFn: () => DashboardAPI.getAllProjects(options),
    select: (data) => data.data,
  });
};

export const useDashboardComponents = (options?: FindProjectsOptions) => {
  return useQuery({
    queryKey: ['dashboard', 'components', options],
    queryFn: () => DashboardAPI.getAllComponents(options),
    select: (data) => data.data,
  });
};

export const useDashboardScores = (options?: DashboardFilterOptions) => {
  return useQuery({
    queryKey: ['dashboard', 'scores', options],
    queryFn: () => DashboardAPI.getScores(options),
    select: (data) => data.data,
  });
};

